export default "../css/a0f6c903c4883c420e7d9e7c682615ac.ttf";